// import DebuggerService from "Services/DebuggerService";
import KeyboardFocusService from "Services/KeyboardFocusService";
import TrackingService from "Services/TrackingService";
import ViewportHeightService from "Services/ViewportHeightService";
import "../components";

export class App {
  constructor() {
    KeyboardFocusService.init();
    ViewportHeightService.init();
    TrackingService.enableTracking();
  }
}
